// テーマはライト固定(背景は application.tailwind.css で白に固定している)。
// 初期の既定値 "system"(2025-06〜07)や "dark" が localStorage に残っている利用者は、
// <html> の data-theme が外れる/dark になり、背景は白のまま dark: 系と daisyUI の dark 配色(白文字)だけが効いて読めなくなる。
// 切替UIは削除済み(Issue #1292)なので、ライト以外の保存値は light に戻す(updateTheme で保存し直される)。
export const normalizeLayoutConfig = (config) => {
    if (config.theme === "light") return config
    return { ...config, theme: "light" }
}

class LayoutCustomizer {
    constructor() {
        this.defaultConfig = {
            theme: "light",
            direction: "ltr",
            sidebarTheme: "light",
            fullscreen: false,
        }
        const configCache = localStorage.getItem("__NEXUS_CONFIG_v2.0__")
        if (configCache) {
            this.config = normalizeLayoutConfig(JSON.parse(configCache))
        } else {
            this.config = { ...this.defaultConfig }
        }
        this.html = document.documentElement
        this.sidebar = document.getElementById("layout-sidebar")

        window.config = this.config
    }

    updateTheme = () => {
        localStorage.setItem("__NEXUS_CONFIG_v2.0__", JSON.stringify(this.config))

        if (this.config.theme === "system") {
            this.html.removeAttribute("data-theme")
        } else {
            this.html.setAttribute("data-theme", this.config.theme)
        }

        if (this.sidebar) {
            if (
                this.config.sidebarTheme === "dark" &&
                ["light", "contrast"].includes(this.config.theme)
            ) {
                this.sidebar.setAttribute("data-theme", this.config.sidebarTheme)
            } else {
                this.sidebar.removeAttribute("data-theme")
            }
        }

        this.html.setAttribute("data-sidebar-theme", this.config.sidebarTheme)
        this.html.dir = this.config.direction

        if (this.config.fullscreen) {
            this.html.setAttribute("data-fullscreen", "")
        } else {
            this.html.removeAttribute("data-fullscreen")
        }
    }

    initEventListener = () => {
        // テーマ切替(data-theme-control / data-sidebar-theme-control)の購読は削除した(Issue #1292)。
        // 唯一の描画元だった partials/_rightbar は render されておらず、コンパイル済みテーマも light のみ。
        // RTL切替(data-dir-control)の購読も描画元が無いため削除した(Issue #1343)。

        const fullscreenControls = document.querySelectorAll("[data-fullscreen-control]")
        fullscreenControls.forEach((control) => {
            control.addEventListener("click", () => {
                if (document.fullscreenElement != null) {
                    this.config.fullscreen = false
                    document.exitFullscreen()
                } else {
                    this.config.fullscreen = true
                    this.html.requestFullscreen()
                }
                this.updateTheme()
            })
        })

        const resetControls = document.querySelectorAll("[data-reset-control]")
        resetControls.forEach((control) => {
            control.addEventListener("click", () => {
                this.config = { ...this.defaultConfig }
                if (document.fullscreenElement != null) {
                    document.exitFullscreen()
                }
                this.updateTheme()
            })
        })

        const fullscreenMedia = window.matchMedia("(display-mode: fullscreen)")
        const fullscreenListener = () => {
            this.config.fullscreen = fullscreenMedia.matches
            this.updateTheme()
        }
        fullscreenMedia.addEventListener("change", fullscreenListener)
        fullscreenListener()
    }

    afterInit = () => {
        this.initEventListener()
    }

    init = () => {
        this.updateTheme()
        window.addEventListener("turbo:load", this.afterInit)
    }
}

new LayoutCustomizer().init()

// Flash Messages Auto-hide
class FlashMessages {
    constructor() {
        this.initFlashMessages()
    }

    initFlashMessages = () => {
        window.addEventListener("turbo:load", () => {
            // Auto-hide flash messages with 'alert-auto-hide' class after 5 seconds
            setTimeout(() => {
                const flashMessages = document.querySelectorAll('.alert.alert-auto-hide')
                flashMessages.forEach((flashMessage) => {
                    flashMessage.style.transition = 'opacity 0.5s ease-out'
                    flashMessage.style.opacity = '0'
                    setTimeout(() => flashMessage.remove(), 500)
                })
            }, 5000)
        })
    }
}

new FlashMessages()
